import SaveIcon from "@mui/icons-material/Save";
import { FormHelperText } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { format, parseISO } from "date-fns";
import React, { useEffect, useRef, useState } from "react";
import {
  IMPACTS_URL,
  TASKS_URL,
  TICKET_ALL_URL,
  USERS_URL,
  STATUS_BY_ID_URL,
  TASKS_UPDATE_URL
} from "../../Constants/Constants";
import { STATUS_SEQ_ID } from "../../Constants/StatusConstants";
import AxiosInstance from "../../services/AxiosInstance";
import { ThemeProvider } from "../v2/home/theme/ThemeProvider";
import { useAlert } from "./../alerts//AlertContext";

function TaskEditDialog({ taskId, statusId }) {
  const [id, setId] = useState("");
  const [status, setStatus] = useState(0);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [due, setDue] = React.useState(null);
  const [assignee, setAssignee] = useState("");
  //const [assignees, setAssignees] = useState([]);

  const [priority, setPriority] = useState(0);
  //const [priorities, setPriorities] = useState([]);

  const [ticket, setTicket] = useState("");
  //const [tickets, setTickets] = useState([]);
  //const [ticketsLoading, setTicketsLoading] = useState(true);

  const [error, setError] = useState(false);

  const [options, setOptions] = useState({
    assignees: [],
    priorities: [],
    tickets: [],
    statuses: []
  });

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    //due: "",
    assignee: "",
    priority: {},
    // ticket: "",
  });

  const [formErrors, setFormErrors] = useState({
    title: "",
    description: "",
    //due: "",
    assignee: "",
    priority: "",
    //ticket: "",
  });

  const [task, setTask] = useState({
    id: "",
    title: "",
    description: "",
    due: "",
    assignee: { id: "" },
    priority: { id: "" },
    status: { id: "" },
    ticket: { id: "" },
  });

  const [open, setOpen] = useState(false);

  const handleFormData = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setFormErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validate = () => {
    const errors = {};

    if (!formData.title.trim()) errors.title = "Title is required";
    if (!formData.description.trim())
      errors.description = "Description is required";
    //if (!formData.due) errors.due = "Due Date is required";
    if (!formData.assignee) errors.assignee = "Assignee is required";

    if (!formData.priority) errors.priority = "Priority is required";

    return errors;
  };

  const initialized = useRef(false);

  useEffect(() => {
    if (
      !initialized.current &&
      options?.priorities?.length > 0 &&
      options?.assignees?.length > 0 &&
      options?.tickets?.length > 0
    ) {
      initialized.current = true;
      initializeSysValues();
    }
  }, [
    options?.priorities,
    options?.assignees,
    options?.tickets
  ]);


  // useEffect(() => {
  //    AxiosInstance.get(IMPACTS_URL).then(res => setOptions(prev => ({ ...prev, priorities: res.data })));
  //   AxiosInstance.get(USERS_URL).then(res => setOptions(prev => ({ ...prev, assignees: res.data })));
  //   AxiosInstance.get(TICKET_ALL_URL).then(res => setOptions(prev => ({ ...prev, tickets: res.data })));
  // }, []);

  useEffect(() => {

    const fetchAll = async () => {
      try {
        const [prioritiesRes, assigneesRes, ticketsRes, statusRef] = await Promise.all([
          AxiosInstance.get(IMPACTS_URL),
          AxiosInstance.get(USERS_URL),
          AxiosInstance.get(TICKET_ALL_URL),
          AxiosInstance.get(STATUS_BY_ID_URL + statusId)
        ]);

        setOptions({
          priorities: prioritiesRes.data,
          assignees: assigneesRes.data.data,
          tickets: ticketsRes.data,
          statuses: statusRef.data
        });
      } catch (err) {
        console.error(err);
      }
    };

    fetchAll();
  }, []);

  const showAlert = useAlert();

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const handleClose = () => {
    setOpen(false);
  };

  const handleTitleChange = (event) => {
    setTitle(event.target.value);
    handleFormData(event);
  };

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
    handleFormData(event);
  };

  const handleAssigneeChange = (event) => {
    setAssignee(event.target.value);
    handleFormData(event);
  };

  const handlePriorityChange = (event) => {
    setPriority(event.target.value);
    handleFormData(event);
  };

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  }
  const handleTicketChange = (event) => {
    setTicket(event.target.value);
    setFormData((prev) => ({
      ...prev,
      ticket: event.target.value,
    }));
  };

  const handleDueDateChange = (date) => {
    // const isoDate = date ? format(date, "yyyy-MM-dd") : null;
    // console.log("Selected Date:", date);
    setDue(date);
  };

  const handleUpdateTask = (event) => {
    saveTask();
  };

  const initializeSysValues = async () => {
    await AxiosInstance.get(`${TASKS_URL}/${taskId}`).then((response) => {
      var taskObj = response.data;
      //setTask(taskObj);
      // setFormData(taskObj);
      setId(taskObj.id);
      setTitle(taskObj.title);
      setDescription(taskObj.description);
      setDue(parseISO(taskObj.due));
      setAssignee(taskObj.assignee);
      setPriority(taskObj.priorityId);
      //setStatus({id:taskObj.statusId});
      setStatus(taskObj.statusId);
      //setTicket({id:taskObj.ticketId});
      setTicket(taskObj.ticketId);
      setTask({ id: taskObj.id, title: taskObj.title, description: taskObj.description, due: taskObj.due, assignee: { id: taskObj.assignee }, priority: { id: taskObj.priorityId }, status: { id: taskObj.statusId }, ticket: { id: taskObj.ticketId } });
      setFormData({ id: taskObj.id, title: taskObj.title, description: taskObj.description, due: taskObj.due, assignee: { id: taskObj.assignee }, priority: { id: taskObj.priorityId }, status: { id: taskObj.statusId }, ticket: { id: taskObj.ticketId } });

    });
  };
  const saveTask = () => {
    const errors = validate();

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
    } else {
      setError(false);
      task.id = taskId;
      task.title = title;
      task.description = description;
      task.due = format(due, "yyyy-MM-dd");
      task.assignee = { id: assignee };
      task.priority = { id: priority };
      task.status = { id: status };
      task.ticket = { id: ticket };

      AxiosInstance.put(TASKS_UPDATE_URL, task)
        .then((response) => {
          showAlert("Task updated successfully!", "success");
          //callTasks();
        })
        .catch((error) => {
          showAlert("Task updation failed!", "error");
          console.error(error);
        });
      handleClose();
    }
  };

  return (
    <ThemeProvider>
      <Box
        component="form"
        sx={{ "& .MuiTextField-root": { m: 1, width: "95%" } }}
        noValidate
        autoComplete="off"
      >
        {/* Title and Status (side by side) */}
        {/* <Box sx={{ display: "flex", width: "97%" }}> */}
        <TextField
          autoFocus
          required
          margin="dense"
          id="outlined-multiline-static"
          name="title"
          label="Title"
          type="text"
          variant="outlined"
          value={formData.title}
          error={!!formErrors.title}
          helperText={formErrors.title}
          onChange={handleTitleChange}
          sx={{ flex: 2 }}
          size="small"
        />
        {/* <TextField
            margin="dense"
            id="status"
            name="status"
            label="Status"
            type="text"
            variant="outlined"
            value={status}
            disabled
            sx={{ flex: 1 }}
          />
        </Box> */}
        {/* Description */}
        <TextField
          autoFocus
          id="outlined-multiline-static"
          name="description"
          label="Description"
          placeholder="Description"
          fullWidth
          multiline
          rows={4}
          cols={10}
          required
          value={formData.description}
          error={!!formErrors.description}
          helperText={formErrors.description}
          onChange={handleDescriptionChange}
          size="small"
        />
        <br />
        {/* Assignee */}
        <FormControl
          variant="outlined"
          sx={{ m: 1, minWidth: "47%" }}
          required
          error={Boolean(formErrors.assignee)}
          size="small"
        >
          <InputLabel size="small" id="demo-simple-select-standard-label">
            Assignee
          </InputLabel>
          <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            name="assignee"
            // value={requestTypeId}
            size="small"
            value={assignee}
            onChange={handleAssigneeChange}
            label="Assignee"
          >
            {options?.assignees?.length > 0 && options.assignees.map((as) => (
              <MenuItem value={as.id}>{as.name}</MenuItem>
            ))}
          </Select>
          {error && <FormHelperText>{formErrors.assignee}</FormHelperText>}
        </FormControl>
        {/* Due Date */}
        <FormControl
          variant="outlined"
          required
          error={Boolean(formErrors.priority)}
          sx={{ minWidth: "48%" }}
        >
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              value={due}
              onChange={handleDueDateChange}
              label="Due Date"
              views={["year", "month", "day"]}
            />
          </LocalizationProvider>
        </FormControl>
        <br />
        {/* Priority */}
        <FormControl
          variant="outlined"
          sx={{ m: 1, minWidth: "47%" }}
          required
          error={Boolean(formErrors.priority)}
        >
          <InputLabel id="demo-simple-select-standard-label">
            Priority
          </InputLabel>
          <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            name="priority"
            value={priority}
            onChange={handlePriorityChange}
            label="Priority"
            size="small"
          >
            {options?.priorities?.length > 0 && options?.priorities.map((pr) => (
              <MenuItem value={pr.id}>{pr.name}</MenuItem>
            ))}
          </Select>
          {error && <FormHelperText>{formErrors.priority}</FormHelperText>}
        </FormControl>
        {/* Ticket */}
        <FormControl
          variant="outlined"
          sx={{ m: 1, minWidth: "46%" }}
          required
          error={Boolean(formErrors.ticket)}
        >
          <InputLabel id="demo-simple-select-standard-label">Ticket</InputLabel>
          <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            name="ticket"
            value={ticket}
            onChange={handleTicketChange}
            label="Ticket"
          >
            {/* {ticketsLoading ? (
              <MenuItem value="" disabled>
                Loading tickets...
              </MenuItem>
            ) : options.tickets?.length === 0 ? (
              <MenuItem value="" disabled>
                No tickets available
              </MenuItem>
            ) : (
              options.tickets.map((tkt) => <MenuItem value={tkt.id}>{tkt.id}</MenuItem>)
            )} */}
            {options?.tickets?.length > 0 && options?.tickets.map((tkt) => (
              <MenuItem value={tkt.id}>{tkt.id}</MenuItem>
            ))}

          </Select>
          {error && <FormHelperText>{formErrors.ticket}</FormHelperText>}
        </FormControl>
        <br />
        {/* Status */}
        <FormControl
          variant="outlined"
          sx={{ m: 1, minWidth: "47%" }}
          required
          error={Boolean(formErrors.ticket)}
        >
          <InputLabel id="demo-simple-select-standard-label">Status</InputLabel>
          <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            name="status"
            value={status}
            onChange={handleStatusChange}
            label="Status"
          >
            {options?.statuses?.length > 0 && options?.statuses.map((st) => (
              <MenuItem value={st.id}>{st.name}</MenuItem>
            ))}

          </Select>
          {error && <FormHelperText>{formErrors.status}</FormHelperText>}
        </FormControl>
        <br />
        {/* Action Buttons */}
        <Button
          variant="contained"
          onClick={handleUpdateTask}
          startIcon={<SaveIcon />}
          sx={{
            float: "right",
            minWidth: 150,
            marginRight: "25px",
            marginTop: "10px",
            background: "linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)",
            boxShadow: "0 3px 5px 2px rgba(25, 118, 210, .3)",
            "&:hover": {
              background: "linear-gradient(45deg, #1565c0 30%, #1976d2 90%)",
            },
          }}
        >
          Update
        </Button>
      </Box>
    </ThemeProvider>
  );
}
export default TaskEditDialog;
